import type { FC } from 'react';

import {
  httpGetGroups,
  httpGetGroupsBasic,
} from '@iconik-io/iconik-api/src/services/users';

import UserNameValue from '../../../../components/select_field_custom_values/select_field_username_value/select_field_username_value';
import { useAppDispatch } from '../../../../store/react_redux_typed';
import type {
  SelectGroupsMultiProps,
  SelectGroupsProps,
} from '../../../../types/select_groups';
import { mapOptions } from '../../../../utils/map_options';
import { prepareQueryParameter } from '../../../../utils/search_utils/search_utils';
import type { SelectOption } from '../../../select_field/types';
import {
  type LoadOptionsResult,
  resolveRemoteResponse,
} from '../../../select_field/utils';
import SelectFieldWrapper from '../select/select';
import SelectFieldMultiWrapper from '../select_multi/select_multi';

export const SelectGroupsFieldWrapper: FC<
  SelectGroupsProps | SelectGroupsMultiProps
> = (props) => {
  const dispatch = useAppDispatch();
  const handleLoadOptions = (query: string): Promise<LoadOptionsResult> => {
    const { loadFullGroups } = props;
    const params = {
      query: prepareQueryParameter(query),
      per_page: 100,
    };

    if (loadFullGroups) {
      return dispatch(httpGetGroups(params)).then(
        resolveRemoteResponse((response) =>
          response.body.objects.map(mapOptions),
        ),
      );
    }
    return dispatch(httpGetGroupsBasic(params)).then(
      resolveRemoteResponse((response) =>
        response.body.objects.map(mapOptions),
      ),
    );
  };

  const handleLoadSelectedOptions = (
    ids: string[],
  ): Promise<SelectOption[]> => {
    const { loadFullGroups } = props;
    const params = {
      ids: ids.join(','),
      per_page: 100,
    };

    if (loadFullGroups) {
      return dispatch(httpGetGroups(params)).then((response) =>
        response.body.objects.map(mapOptions),
      );
    }
    return dispatch(httpGetGroupsBasic(params)).then((response) =>
      response.body.objects.map(mapOptions),
    );
  };

  const sharedProps = {
    preloadOptions: true,
    valueComponent: UserNameValue,
    loadOptions: handleLoadOptions,
    loadSelectedOptions: handleLoadSelectedOptions,
  };

  if (props.isMulti) {
    return <SelectFieldMultiWrapper {...props} {...sharedProps} />;
  }

  return <SelectFieldWrapper {...props} {...sharedProps} />;
};

export default SelectGroupsFieldWrapper;
